// extracted by mini-css-extract-plugin
export default {"container":"SB-z","ratingLayout":"TB-z","ratingLabel":"UB-z"};